import React from 'react';
import { ProjectNote, ProjectNoteRequest, useProjectNotesService, ProjectPermission } from 'nekst-api';
import { TextAreaWithProjectMemberMention, ProjectIdContext } from 'features/nekst-widgets';
import { FormTemplate, CheckboxInput, SubmitButton, CancelButton, AfterSubmitFunc } from 'ui-builder';
import { useAuthorizationChecker } from 'authorization-scope';

interface Props {
  projectId: number;
  afterSubmitFunc?: AfterSubmitFunc,
}

export default function CreateNoteForm(props: Props) {
  const projectNotesService = useProjectNotesService();
  const { isGranted } = useAuthorizationChecker();

  return (
    <ProjectIdContext projectId={props.projectId}>
      <FormTemplate<ProjectNoteRequest, ProjectNote>
        title="Add Note"
        submitFormFunc={async (data: ProjectNoteRequest) => {
          return await projectNotesService.createNote(props.projectId, data) as ProjectNote;
        }}
        afterSubmitFunc={props.afterSubmitFunc}
        validationSchema={{
          text: {
            type: 'string',
            constraints: {
              required: true,
            },
          },
        }}
        buttons={(
          <>
            <SubmitButton />
            <CancelButton />
          </>
        )}
      >
        <TextAreaWithProjectMemberMention
          source="text"
          label="Enter Note Here"
          showRequiredIcon={false}
        />
        {isGranted(ProjectPermission.ASSIGN_NOTE_TO_CLIENT_PORTAL) && (
          <CheckboxInput
            source="isAddedToClientPortal"
            label="Add this note to the Client Portal"
          />
        )}
      </FormTemplate>
    </ProjectIdContext>
  );
}
